<template>
  <div class="custom-input-area">
    <n-input-number
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :size="size"
      :clearable="true"
      :bordered="bordered"
      class="custom-input"
      :class="{ 'input-no-border': bordered }"
      v-if="isInputNumber"
      @update:value="(value) => emit('update:modelValue', value)"
    ></n-input-number>
    <n-input
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="true"
      :size="size"
      class="custom-input"
      :bordered="bordered"
      :type="type"
      :show-password-on="showPasswordOn"
      :class="{ 'input-no-border': bordered }"
      @update:value="(value) => emit('update:modelValue', value)"
      v-else
    >
      <template #prefix>
        <CustomIcon
          :type="prefixIcon"
          :size="prefixIconSize"
          color="#999"
        ></CustomIcon>
      </template>
      <template #suffix>
        <slot name="suffix"></slot>
      </template>
    </n-input>
  </div>
</template>

<script setup lang="ts">
// 定义Emits接口
interface SelectFieldEmits {
  (
    e: 'update:modelValue',
    value: string | number | boolean | (string | number | boolean)[] | undefined
  ): void
}
const props = withDefaults(
  defineProps<{
    modelValue: string | number | undefined
    placeholder?: string
    disabled?: boolean
    size?: 'tiny' | 'small' | 'medium' | 'large'
    showPassword?: boolean
    type?: 'text' | 'password' | 'textarea'
    showPasswordOn?: string // 是否显示密码眼睛
    isInputNumber?: boolean
    readonly?: boolean
    [key: string]: any
    bordered?: boolean
    prefixIcon?: string
    prefixIconSize?: string | number
  }>(),
  {
    showPassword: false,
    isInputNumber: false,
    type: 'text'
  }
)
const emit = defineEmits<SelectFieldEmits>()
</script>
<style lang="scss" scoped>
.custom-input-area {
  width: 100%;
  .custom-input {
    border-radius: 8px;
    border: 1px solid #bbb;
    &.input-no-border {
      border: none;
    }
    :deep(.n-input__placeholder) {
      font-size: 12px !important;
    }
  }
}
</style>
